export class WhiteLabelInfo {
    companyUri: string;
    contactEmail: string;
    disclaimers: { [key: string]: string };
}
